module.exports = __webpack_public_path__ + "bab368e957802ecb2af6c02c78982e3b.png";